import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import CustomAlert from "../../components/CustomAlert";
import CustomDrawer from "../../components/CustomDrawer";
import CustomLoading from "../../components/CustomLoading";
import { paths } from "../../config/router.config";
import wsclients from "../../services/wsclients";
import { dataUtil } from "../../services/wsclients/dataUtil";
import { getCurrency, getProviderOrder, getUTMInfo, saveDataIntoAsyncStore, setCurrency, setDataChangeService, setOrderStatusInfo, setProfile, setProviderOrder, setUTMInfo } from "../../utils/commons";
import { order_key, setOrderStatusCache } from "../../utils/order_cache";
import OrderProgress from "../orders/OrderProgress";
import ChangeServicesView from "../subcriptions/ChangeServicesView";
import { ServiceDetailController } from "../subcriptions/ServiceDetailController";
import ServiceDetailView from "../subcriptions/ServiceDetailView";
import HomeView from "./HomeView";
import TerminateConfirm from "../subcriptions/TerminateConfirm";
import OrderExpireView from "./OrderExpireView";
import ChangeBillingDay from "./ChangeBillingDay";
import { lab4services } from "../../services/wsclients/lab4services";
import ProcessFormView from "../register/ProcessFormView";

export default function HomeController(props){
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [showDrawer, setShowDrawer] = useState({});
    const [supports, setSupports] = useState([]);
    const [contact, setContact] = useState(null);
    const [orderStatus, setOrderStatus] = useState(null);
    const [service_requests, setServiceRequests] = useState([]);
    const [periodSelected, setPeriodSelected] = useState(null);
    const [periods, setPeriod] = useState([]);
    const [subcriptions, setSubcriptions] = useState(null);
    const [changeServices, setChangeServices] = useState([]);
    const [showChangeServices, setShowChangeServices] = useState(false);
    const [subscriptionSelected, setSubcriptionSelected] = useState(null);
    const [showDetailService, setShowDetailService] = useState(false);
    const [serviceChangeSelected, setServiceChangeSelected] = useState(null);
    const [serviceDetail, setServiceDetail] = useState(null);

    const [activeStep, setActiveStep] = useState(0);
    const [showProgress, setShowProgress] = useState(false);
    const [showButtonClose, setShowButtonClose] = useState(false);
    const [resultProgress, setResultProgress] = useState({
        step: 0,
        status: null,
        code: null,
        message: null
    });
    const [reasonSelected, setReasonSelected] = useState(null);
    const [listReason, setListReason] = useState([]);
    const [showConfirmTerminate, setShowConfirmTerminate] = useState(false);
    const [terminateSelected, setTerminateSelected] = useState(null);
    const [showButtonReOrder, setShowButtonReOrder] = useState(false);
    const [showOrderExpireDetail, setShowOrderExpireDetail] = useState(false);
    const [orderExpireDetail, setOrderExpireDetail] = useState(null);
    const [showBillingDay, setShowBillingDay] = useState(false);
    const [htmlContent, setHtmlContent] = useState(null);
    const [openProcessForm, setOpenProcessForm] = useState(false);
    const [providerOrder, setProviderOrder] = useState(null);

    const {t} = useTranslation();
    let history = useHistory();

    useEffect(()=>{
        onLoad();
    },[])

    const onLoad = async () => {
        onShowLoading(true);
        var url = new URL(window.location.href);
        console.log("url===", url);
        var utm_source = url.searchParams.get("utm_source");
        var utm_campain = url.searchParams.get("utm_campaign");
        let utm_info = getUTMInfo();
        if(utm_info && utm_info.utm_source && utm_info.utm_campain){
            console.log("AAAAA on update campain====");
            await onUpdateCampain(utm_info.utm_source, utm_info.utm_campain);
            setUTMInfo(null)
        }
        else if(utm_source && utm_campain){
            console.log("AAAAA on update campain====");
            await onUpdateCampain(utm_source, utm_campain);
            setUTMInfo(null)
        }
        
        let contact_info = await onLoadContact();
        console.log("contact_info==", contact_info);
        if(contact_info) {
            await onGetOrderStatus(contact_info.id);
        }
        await getListServiceRequests();
        onShowLoading(false);
    }
    
    const onLoadContact =  async () => {
        let contact_info = null;
        try{
            var result = await wsclients.contacts.getContact();
            if(result.code === 'OK'){
                contact_info = result.data;
                setContact(result.data);
                if(result.data && result.data.custom_fields && result.data.custom_fields.length > 0) {
                    let existProviderOrder = result.data.custom_fields.filter(x => x.key == 'provider_order');
                    if(existProviderOrder && existProviderOrder.length > 0) {
                        setProviderOrder(existProviderOrder[0].value);
                    }
                }
            }
        }catch(ex){
            console.log("onLoadContact exception===", ex);
        }
        return contact_info;
    }

    const onUpdateCampain = async (utm_source, utm_campain) => {
        try {
            var result = await wsclients.lab4services.updateCampain(utm_source, utm_campain);
            console.log("updateCampain result====", result);
        }
        catch (ex) {
            console.log("updateCampain exception===", ex);
        }
    }
    const onGetOrderStatus =  async (contact_id) => {
        try{
            let provider_order = getProviderOrder();
            var result = await wsclients.lab4services.getOrderStatus(contact_id, null, provider_order);
            console.log("result order status ===", result);
            if(result.code === 'OK'){
                let order_status = result.data;
                setOrderStatus(result.data);
                // setOrderStatusInfo(result.data);
                if(result.data) setOrderStatusCache(order_key.order_status, JSON.stringify(result.data))
                if(order_status){
                    // if((order_status.status === 'VUMATEL_ORDER_EXCEPTION'))
                    //     history.push(paths.package_contact);
                    // else 
                    if(order_status.status === 'COMPLETE'){
                        await onInit();
                    }
                    else if(order_status.status === 'PAYMENT_EXPIRE'){
                        setShowButtonReOrder(true);
                    }
                }
            }
        }catch(ex){
            console.log("onGetOrderStatus exception===", ex);
        }
    }

    const onLoadSupportRequest = async () => {
        try{
            const rows = [
                { id: 112233, holder_name: 'Account and Billing', subject: 'Support Request-44', mess: 'send me invoice', default: 'True', status: 'Pending', prioty: 'low', datetime: '28/12/2021 12:06' },
                { id: 112234, holder_name: 'Account and Billing', subject: 'Support Request-44', mess: 'send me invoice', default: 'True', status: 'Pending', prioty: 'up', datetime: '28/12/2021 12:06' },
            ]
            setSupports(rows);
        }catch(ex){

        }
    }

    const onShowMessage = (message)=>{
        onShowLoading(false)
        setMessage(message)
    }

    const onContinuePayment = async() => {
        // if(orderStatus && orderStatus.vumatelPaymentUrl){
        //     window.location.href = orderStatus.vumatelPaymentUrl;
        // }
        onShowLoading(true)
        try{
            let body = {
                contact_id: contact.id,
            }
            if(orderStatus && orderStatus.productType === 'openserve') body.product_type = orderStatus && orderStatus.productType ? orderStatus.productType : null;
            var result = await wsclients.lab4services.continuePayment(body);
            if(result.code === 'OK'){
                onShowMessage({show: true, content: t('wait_to_redirect_payment')});
                if(result.data){
                    if(orderStatus && orderStatus.productType === 'openserve') {
                        window.location.href = result.data.paymentUrl;
                    }
                    else if(result.data.vumatelPaymentUrl)
                        window.location.href = result.data.vumatelPaymentUrl;
                }
                onShowLoading(true)
                // onShowMessage({show: true, content: t('PAYMENT_SUCCESS')});
            }else{
                onShowMessage({show: true, content: t('PAYMENT_FAILED')});
            }
        }catch(ex){
            console.log("continue payment exception===", ex);
        }
        onShowLoading(true)
    }

    const getListServiceRequests = async () => {
        let result = await wsclients.config.getListServiceRequests();
        if (result.code === 'OK' && result.data && result.data.content) {
            setServiceRequests(result.data.content);
        }
        console.log('getListServiceRequests ====', result);
    }

    const onInit = async () => {
        let data = await onLoadSubcriptions();
        if (data && data.length > 0) {
            let periodData = dataUtil.groupBillingPeriod(data);
            console.log("periodData===", periodData);
            if (periodData && periodData.length > 0) {
                setPeriodSelected(periodData[0]);
            }
        }
    }

    const onChangeTab = (period) => {
        setPeriodSelected(period);
    }

    const onLoadSubcriptions = async (isRefresh) => {
        onShowLoading(isRefresh ? false : true);
        var subscriptionServices = [];
        try {
            const result = await wsclients.contacts.getListContactServices();
            console.log("result:", result);
            if (result.code == 'OK') {
                let data = result.data.content ? result.data.content : []
                for (let i = 0; i < data.length; i++) {
                    let subscriptionService = data[i];
                    let product = subscriptionService.service ? subscriptionService.service.product : null;
                    if(subscriptionService.service && subscriptionService.service.price && subscriptionService.service.price.price){
                        product.price = subscriptionService.service.price.price;
                    }
                    if(product) {
                        // let info = await wsclients.contacts.getProductDetail(product.id);
                        let info = await wsclients.lab4services.getServiceProduct(product.id);
                        console.log("product info:", info);
                        if (info.code == 'OK') {
                            console.log("info.data.creatives:", info.data.creatives);
                            product.creatives = info.data.creatives;
                            if(info.data && info.data.price) product.price = info.data.price;
                            product.family = info.data.family ? info.data.family : null;
                            product.type = info.data && info.data.type ? info.data.type : null;
                        }
                    }
                    subscriptionServices.push(subscriptionService);
                }
            }
            console.log("subscriptionServices:", subscriptionServices);
            setSubcriptions(subscriptionServices);
            // setPeriod(dataUtil.groupBillingPeriod(subscriptionServices));
        } catch (ex) {
            console.log("on load subscription ex:", ex);
        }
        onShowLoading(false);
        return subscriptionServices;
    }

    const onGoToPage = (url) => {
        history.push(url);
    }

    const onSwarpService = async (subscription) => {
        try{
            onShowLoading(true);
            setSubcriptionSelected(subscription);
            let product = subscription && subscription.service && subscription.service.product ? subscription.service.product : null;
            let result = await wsclients.lab4services.getChangeServices(product && product.id ? product.id : null);
            if(result.code === 'OK'){
                if(result.data){
                    setChangeServices(result.data);
                    setShowChangeServices(true);
                }else{
                    onShowMessage({show: true, content: t('can_not_up_downgrade')});
                }
            }
            onShowLoading(false);
        }
        catch(ex){
            console.log("onSwarpService exception===", ex);
        }
    }

    const onEstimateServices = async (service) => {
        console.log("service onEstimateServices===", service);
        onShowLoading(true)
        try{
            let price = service && service.prices && service.prices.length > 0 ? service.prices[0] : null;
            setServiceChangeSelected(service);
            let result = await wsclients.lab4services.onEstimateServices({
                action: service.change_type,
                from_service_id: subscriptionSelected && subscriptionSelected.service && subscriptionSelected.service.id ? subscriptionSelected.service.id : null,
                to_service_id: service && service.id ? service.id : null,
                to_price_terms_id: price && price.id ? price.id : null,
                scheduled_date:subscriptionSelected.service.terms.termed_period.end_date
            });
            console.log("result onEstimateServices===", result);
            if(result.code === 'OK'){
                let total = 0;

                if (result?.data?.service_delivery_estimate?.length > 0) {
                for (let i = 0; i < result.data.service_delivery_estimate.length; i++) {
                    const element = result.data.service_delivery_estimate[i];
                    const invoicingList = element.billing_estimate?.invoicing || [];
                    
                    for (let j = 0; j < invoicingList.length; j++) {
                    total += invoicingList[j]?.amount_due || 0;
                    }
                }
                }
                console.log("AAAA total",total)
                if(total > 0){
                    setDataChangeService({
                        scheduled_date:subscriptionSelected.service.terms.termed_period.end_date,
                        price_terms_id:service&& service.prices && service.prices.length>0&&
                        service.prices[0].id,
                        product_id:service.id,
                        status_payment:false
                    })
                     await onContinuePaymentMetrofibre(total);
                    return;
                }
                setServiceDetail(result.data);
                setShowDetailService(true);
            }else{
                onShowMessage({show: true, content:result?.data?.error?.message?result?.data?.error?.message : t('change_service_failed') })
            }
        }
        catch(ex){
            console.log("onChangeServices exception===", ex);
        }
        onShowLoading(false)
    }
    const onContinuePaymentMetrofibre = async (amount) => {
      
        try {
            let contact_info = await wsclients.contacts.getContact();
            if(contact_info.code != "OK"){
                onShowMessage({
                    show: true,
                    message: "Contact not found",
                    isConfirm: true,
                    confirmAction: {
                        okAction: async () => await onContinuePayment(amount),
                        okTitle: t('btn_try'),
                        cancelTitle: t('btn_close'),
                        cancelAction: () => history.push(paths.home),
                    },
                })
            }
            contact_info = contact_info.data;
            let body = {
                contact_id: contact_info.id ? contact_info.id : null,
                email_address: contact_info && contact_info.email ? contact_info.email : null,
                contact_code: contact_info && contact_info.code ? contact_info.code : null,
                amount: amount,
                crm_order_id:"8b1511a0-64b8-4a75-ad1e-aec00ae542e1"
            };
            // debugger;
            let  result = await lab4services.initTopup(body);
           
            console.log("AAAA initPayment result: ", result);
            if (result.code == 'OK') {
                let urlFormPaygate = document._portalConfig.urlFormPaygate;
                if (result && result.code === 'OK' && result.data && result.data.client_token) {
                    let clientToken = result.data.client_token;
                    var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                    console.log('splitToken:', splitToken);
                    if (splitToken.length > 0) {
                        var payRequestIDRes = splitToken[0];
                        var checkSumRes = splitToken[1];
                        var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                            + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                            + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                            + '</form>'
                        console.log('htmlContent:', htmlContent);
                        // setPaymentLinkInfo(paymentInfo);
                        setHtmlContent(htmlContent);
                        setOpenProcessForm(true);
                    }
                } else if (result.data && result.data.state === 'REJECTED') {
                    onShowMessage({
                        show: true,
                        message: t('INIT_PAYMENT_FAILED'),
                        isConfirm: true,
                        confirmAction: {
                            okAction: async () => await onContinuePayment(amount),
                            okTitle: t('btn_try'),
                            cancelTitle: t('btn_close'),
                            cancelAction: () => history.push(paths.home),
                        },
                    });
                }
            }
        } catch (ex) {
            console.log("AAAA onContinuePayment exception: ", ex);
        }
       
    }

    const onTerminate = async (values) => {
        onShowMessage({});
        onShowLoading(true);
        setShowProgress(true);
        setShowConfirmTerminate(false);
        try {
            const { reason_id } = values;
            let service_id = terminateSelected && terminateSelected.service && terminateSelected.service.id ? terminateSelected.service.id : null;
            let serviceFrom = terminateSelected && terminateSelected.service && terminateSelected.service.product ? terminateSelected.service.product : null
            console.log("serviceFrom AAAAAA===", serviceFrom);
            let current_product_id = serviceFrom && serviceFrom.id ? serviceFrom.id : null;
            await onTerminateVumatel(service_id, reason_id, current_product_id);
        } catch (ex) {
            console.log("onTerminate exception===", ex);
        }
        onShowLoading(false)
        // setShowProgress(false);
    }

    const onTerminateVumatel = async (service_id, reason_id, current_product_id) => {
        onShowLoading(true)
        try{
            let result = await wsclients.lab4services.onTerminateVumatel(service_id, reason_id, current_product_id);
            console.log("onTerminateVumatel result ====", result);
            if(result.code === 'OK'){
                setActiveStep(1);
                setResultProgress({
                    step: 1,
                    status: 'terminate_vumatel_success',
                    message: t('terminate_vumatel_success')
                });
                await onTerminateCRM(service_id);
            } else if(result.code === 'VUMATEL_SERVER_ERROR'){
                setActiveStep(0);
                setResultProgress({
                    step: 0,
                    status: 'ERROR',
                    message: t('VUMATEL_SERVER_ERROR')
                });
                setShowButtonClose(true);
            }
            else{
                let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                setActiveStep(0);
                setResultProgress({
                    step: 0,
                    status: 'ERROR',
                    message: entityError && entityError.detail && typeof(entityError.detail) === 'string' ? entityError.detail : t('terminate_vumatel_failed')
                });
                setShowButtonClose(true);
            }
            // await onTerminateCRM(service_id);
        }
        catch(ex){
            console.log("onTerminateVumatel exception===", ex);
        }
        onShowLoading(false)
    }

    const onTerminateCRM = async (service_id) => {
        onShowLoading(true)
        try{
            let result = await wsclients.lab4services.onTerminateCRM(service_id);
            console.log("onTerminateCRM result ====", result);
            if(result.code === 'OK'){
                setActiveStep(2);
                setResultProgress({
                    step: 2,
                    status: 'terminate_crm_success',
                    message: t('terminate_crm_success')
                });
                await onInit();
                setShowButtonClose(true);
                setShowProgress(false);
            }else{
                setActiveStep(1);
                setResultProgress({
                    step: 1,
                    status: 'ERROR',
                    message: t('terminate_crm_failed')
                });
                setShowButtonClose(true);
            }
        }
        catch(ex){
            console.log("onTerminateCRM exception===", ex);
        }
        onShowLoading(false)
    }

    const getSteps = () => {
        if (providerOrder && providerOrder == 'openserve') {
            return [t('change_service_openserve'), t('change_service_crm')];
        } else if(providerOrder && providerOrder == 'metrofibre'){
            return [];
        } else{
            return [t('change_service_vumatel'), t('change_service_crm')];
        }
    }
    const onCloseProgress = () => {
        setShowProgress(false);
        setResultProgress({
            step: 0,
            status: null,
            message: null
        });
    }

    const getTerminateReason = async () => {
        let list_reason = [];
        onShowLoading(true)
        try{
            let result = await wsclients.lab4services.getTerminateReason();
            console.log("getTerminateReason result ====", result);
            if(result.code == 'OK'){
                list_reason = result.data.filter(x => x.active === true);
                setListReason(list_reason);
                setShowConfirmTerminate(true)
            }
        }
        catch(ex){
            console.log("getTerminateReason exception===", ex);
        }
        onShowLoading(false)
        return list_reason;
    }

    const onConfirmTerminate = async (service) => {
        try{
            setTerminateSelected(service);
            console.log("subscriptionSelected AAAAAA===", subscriptionSelected);
            let list_reason = await getTerminateReason();
            if(list_reason && list_reason.length > 0){
                setShowConfirmTerminate(true);
            }
        }
        catch(ex){
            console.log("onConfirmTerminate exception===", ex);
        }
    }

    const onGetOrderExpire = async () => {
        onShowLoading(true);
        try{
            let result = await wsclients.lab4services.onGetOrderExpire();
            if(result.code == 'OK'){
                onShowLoading(false);
                setOrderExpireDetail(result.data);
                setShowOrderExpireDetail(true);
            }
        }
        catch(ex){
            console.log("onGetOrderExpire exception===", ex);
        }
        onShowLoading(false);
    }

    const onReOrderExpire = async () => {
        onShowLoading(true)
        try{
            let result = await wsclients.lab4services.onReOrderExpire();
            if(result.code === 'OK'){
                onShowLoading(false)
                if(result.data && result.data.vumatel_payment_url) window.location.href = result.data.vumatel_payment_url;
            }else if(result.code === 'VUMATEL_SERVER_ERROR'){
                onShowMessage({show: true, title: t('ERROR'), content: t('VUMATEL_SERVER_ERROR') });
            }
            else{
                onShowLoading(false)
                let entityError = result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : null;
                let messError = entityError && entityError.detail && typeof(entityError.detail) === 'string' ? entityError.detail : t('REORDER_EXPIRE_FAILED')
                onShowMessage({show: true, title: t('ERROR'), content: messError });
            }
        }
        catch(ex){
            console.log("onReOrderExpire exception===", ex);
        }
        onShowLoading(false)
    }

    const onContinueOrder = async () => {
        onShowLoading(true)
        try{
            var result = await wsclients.lab4services.continuePayment({
                contact_id: contact.id,
                product_type: orderStatus && orderStatus.productType ? orderStatus.productType : null,
            });
            if(result.code === 'OK'){
                if(result.data){
                    onShowMessage({show: true, content: t('PAYMENT_SUCCESS')});
                    await onLoad();
                }
            }else{
                onShowMessage({show: true, content: t('PAYMENT_FAILED')});
            }
        }catch(ex){
            console.log("continue payment exception===", ex);
        }
        onShowLoading(true)
    }

    const onChangeBillingDay = (item) => {
        setSubcriptionSelected(item);
        setShowBillingDay(true);
    }

    console.log("message===", message)

    return(
        <>
            <HomeView 
                showDrawer={showDrawer}
                supports={supports}
                contact={contact}
                orderStatus={orderStatus}
                service_requests={service_requests}
                periods={periods}
                subcriptions={subcriptions}
                periodSelected={periodSelected}
                changeServices={changeServices}
                showChangeServices={showChangeServices}
                showButtonReOrder={showButtonReOrder}
                currency={getCurrency()}
                onChangeTab={onChangeTab}
                onContinuePayment={onContinuePayment}
                onGoToPage={onGoToPage}
                onSwarpService={onSwarpService}
                setShowChangeServices={setShowChangeServices}
                onTerminate={onConfirmTerminate}
                onGetOrderExpire={onGetOrderExpire}
                onContinueOrder={onContinueOrder}
                onChangeBillingDay={onChangeBillingDay}
            />
             {openProcessForm && <ProcessFormView
                open={openProcessForm}
                onClose={() => setOpenProcessForm(false)}
                html_content={htmlContent}
            />}
            {showChangeServices && <ChangeServicesView 
                open={showChangeServices}
                changeServices={changeServices}
                currency={getCurrency()}
                onClose={() => setShowChangeServices(false)}
                onEstimateServices={onEstimateServices}
            />}
            {showDetailService && <ServiceDetailController 
                open={showChangeServices}
                service={serviceDetail}
                serviceChangeSelected={serviceChangeSelected}
                subscriptionSelected={subscriptionSelected}
                providerOrder={providerOrder}
                currency={getCurrency()}
                onClose={() => setShowDetailService(false)}
                onCloseAll={() => {
                    setShowDetailService(false)
                    setShowChangeServices(false)
                }}
                onLoad={onLoad}
            />}
            { message.show && <CustomAlert
                open = {message.show}
                title={message.title}
                message = {message.content}
                customMessage={message.customMessage}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                onClose = {()=>onShowMessage({})}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                showButtonClose={true}
                />}
            {showProgress &&  <OrderProgress
                open={showProgress}
                t={t}
                orderInfo={resultProgress}
                title={providerOrder == 'metrofibre'?t('change_service'):t('terminate_service')}
                sub_title={providerOrder == 'metrofibre'?t('change_service_progress'):t('terminate_service_progress')}
                steps={getSteps()}
                activeStep={activeStep}
                showButtonClose={showButtonClose}
                onClose={() => onCloseProgress()}
            />}
            
            {showConfirmTerminate && <TerminateConfirm 
                open={showConfirmTerminate}
                reasonSelected={reasonSelected}
                listReason={listReason}
                onTerminate={onTerminate}
                onClose={() => setShowConfirmTerminate(false)}
            />}
            {showOrderExpireDetail && <OrderExpireView 
                open={showOrderExpireDetail}
                detail={orderExpireDetail}
                currency={getCurrency()}
                onClose={() => setShowOrderExpireDetail(false)}
                onReOrderExpire={onReOrderExpire}
            />}
            {showLoading && <CustomLoading open={showLoading}/>}
            {showBillingDay && <ChangeBillingDay 
                open={showBillingDay}
                onClose={() => setShowBillingDay(false)}
                subscriptionSelected={subscriptionSelected}
                onRefresh={onLoad}
            />}
        </>
    )
}